export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    hashrate: 0.71,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1234/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    hashrate: 1.29,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1238/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    hashrate: 1.9,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1245/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    hashrate: 2.09,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1247/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    hashrate: 2.09,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1252/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    hashrate: 2.3,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1256/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    hashrate: 2.7,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1259/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    hashrate: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    hashrate: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    hashrate: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    hashrate: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    hashrate: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    hashrate: 0.7,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1254/marathon-digital-holdings-reports-second-quarter-2021"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    hashrate: 2.09,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1254/marathon-digital-holdings-reports-second-quarter-2021"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    hashrate: 2.7,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1259/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    hashrate: 0,
    source: ""
  },
]
